export default __webpack_public_path__ + "static/media/mixology-mobile@2x.2a9ee097.png";